import React, { useState } from 'react';
import { X, ChevronLeft } from 'lucide-react';
import { ALL_FORM_FIELDS } from '../../utils/fieldDefinitions.js';
import PhotoUploadField from './PhotoUploadField.js';

// 大使馆选项列表（按自定义顺序排列）
const embassyOptions = [
  // 1. 中国（含港台）- 7个
  { value: 'WUH', label: '中国武汉' },
  { value: 'BEJ', label: '中国北京' },
  { value: 'GUZ', label: '中国广州' },
  { value: 'SHG', label: '中国上海' },
  { value: 'SNY', label: '中国沈阳' },
  { value: 'HNK', label: '中国香港' },
  { value: 'TAI', label: '中国台北' },
  // 2. 墨西哥（西班牙语）- 10个
  { value: 'CDJ', label: 'MÉXICO, CIUDAD JUÁREZ' },
  { value: 'GDL', label: 'MÉXICO, GUADALAJARA' },
  { value: 'HER', label: 'MÉXICO, HERMOSILLO' },
  { value: 'MTM', label: 'MÉXICO, MATAMOROS' },
  { value: 'MER', label: 'MÉXICO, MÉRIDA' },
  { value: 'MEX', label: 'MÉXICO, CIUDAD DE MÉXICO' },
  { value: 'MTR', label: 'MÉXICO, MONTERREY' },
  { value: 'NGL', label: 'MÉXICO, NOGALES' },
  { value: 'NVL', label: 'MÉXICO, NUEVO LAREDO' },
  { value: 'TJT', label: 'MÉXICO, TIJUANA' },
  // 3. 越南（越南语）- 2个
  { value: 'HAN', label: 'VIỆT NAM, HÀ NỘI' },
  { value: 'HCM', label: 'VIỆT NAM, HỒ CHÍ MINH' },
  // 4. 印度（英语）- 5个
  { value: 'MDR', label: 'INDIA, CHENNAI' },
  { value: 'HYD', label: 'INDIA, HYDERABAD' },
  { value: 'CLC', label: 'INDIA, KOLKATA' },
  { value: 'BMB', label: 'INDIA, MUMBAI' },
  { value: 'NWD', label: 'INDIA, NEW DELHI' },
  // 5. 巴西（葡萄牙语）- 5个
  { value: 'BRA', label: 'BRASIL, BRASÍLIA' },
  { value: 'PTA', label: 'BRASIL, PORTO ALEGRE' },
  { value: 'RCF', label: 'BRASIL, RECIFE' },
  { value: 'RDJ', label: 'BRASIL, RIO DE JANEIRO' },
  { value: 'SPL', label: 'BRASIL, SÃO PAULO' },
  // 6. 哥伦比亚（西班牙语）- 1个
  { value: 'BGT', label: 'COLOMBIA, BOGOTÁ' },
  // 7. 其他国家（按英文字母顺序）
  { value: 'TIA', label: 'ALBANIA, TIRANA' },
  { value: 'ALG', label: 'ALGERIA, ALGIERS' },
  { value: 'LUA', label: 'ANGOLA, LUANDA' },
  { value: 'BNS', label: 'ARGENTINA, BUENOS AIRES' },
  { value: 'YRV', label: 'ARMENIA, YEREVAN' },
  { value: 'MLB', label: 'AUSTRALIA, MELBOURNE' },
  { value: 'PRT', label: 'AUSTRALIA, PERTH' },
  { value: 'SYD', label: 'AUSTRALIA, SYDNEY' },
  { value: 'VNN', label: 'AUSTRIA, VIENNA' },
  { value: 'BKU', label: 'AZERBAIJAN, BAKU' },
  { value: 'NSS', label: 'BAHAMAS, NASSAU' },
  { value: 'MNA', label: 'BAHRAIN, MANAMA' },
  { value: 'DHK', label: 'BANGLADESH, DHAKA' },
  { value: 'BGN', label: 'BARBADOS, BRIDGETOWN' },
  { value: 'BRS', label: 'BELGIUM, BRUSSELS' },
  { value: 'BLZ', label: 'BELIZE, BELMOPAN' },
  { value: 'COT', label: 'BENIN, COTONOU' },
  { value: 'HML', label: 'BERMUDA, HAMILTON' },
  { value: 'LPZ', label: 'BOLIVIA, LA PAZ' },
  { value: 'SAR', label: 'BOSNIA-HERZEGOVINA, SARAJEVO' },
  { value: 'GAB', label: 'BOTSWANA, GABORONE' },
  { value: 'BSB', label: 'BRUNEI, BANDAR SERI BEGAWAN' },
  { value: 'SOF', label: 'BULGARIA, SOFIA' },
  { value: 'OUG', label: 'BURKINA FASO, OUAGADOUGOU' },
  { value: 'RNG', label: 'BURMA, RANGOON' },
  { value: 'BUJ', label: 'BURUNDI, BUJUMBURA' },
  { value: 'PIA', label: 'CABO VERDE, PRAIA' },
  { value: 'PHP', label: 'CAMBODIA, PHNOM PENH' },
  { value: 'YDE', label: 'CAMEROON, YAOUNDE' },
  { value: 'CLG', label: 'CANADA, CALGARY' },
  { value: 'HLF', label: 'CANADA, HALIFAX' },
  { value: 'MTL', label: 'CANADA, MONTREAL' },
  { value: 'OTT', label: 'CANADA, OTTAWA' },
  { value: 'QBC', label: 'CANADA, QUEBEC' },
  { value: 'TRT', label: 'CANADA, TORONTO' },
  { value: 'VAC', label: 'CANADA, VANCOUVER' },
  { value: 'NDJ', label: 'CHAD, N`DJAMENA' },
  { value: 'SNT', label: 'CHILE, SANTIAGO' },
  { value: 'BRZ', label: 'CONGO, BRAZZAVILLE' },
  { value: 'KIN', label: 'CONGO, KINSHASA' },
  { value: 'SNJ', label: 'COSTA RICA, SAN JOSE' },
  { value: 'ABJ', label: 'COTE D`IVORIE, ABIDJAN' },
  { value: 'ZGB', label: 'CROATIA, ZAGREB' },
  { value: 'HAV', label: 'CUBA, HAVANA' },
  { value: 'CRC', label: 'CURACAO, CURACAO' },
  { value: 'NCS', label: 'CYPRUS, NICOSIA' },
  { value: 'PRG', label: 'CZECH REPUBLIC, PRAGUE' },
  { value: 'CPN', label: 'DENMARK, COPENHAGEN' },
  { value: 'DJI', label: 'DJIBOUTI, DJIBOUTI' },
  { value: 'SDO', label: 'DOMINICAN REPUBLIC, SANTO DOMINGO' },
  { value: 'GYQ', label: 'ECUADOR, GUAYAQUIL' },
  { value: 'QTO', label: 'ECUADOR, QUITO' },
  { value: 'CRO', label: 'EGYPT, CAIRO' },
  { value: 'SNS', label: 'EL SALVADOR, SAN SALVADOR' },
  { value: 'LND', label: 'ENGLAND, LONDON' },
  { value: 'MBO', label: 'EQUATORIAL GUINEA, MALABO' },
  { value: 'ASM', label: 'ERITREA, ASMARA' },
  { value: 'TAL', label: 'ESTONIA, TALLINN' },
  { value: 'MBA', label: 'ESWATINI, MBABANE' },
  { value: 'ADD', label: 'ETHIOPIA, ADDIS ABABA' },
  { value: 'SUV', label: 'FIJI, SUVA' },
  { value: 'HLS', label: 'FINLAND, HELSINKI' },
  { value: 'PRS', label: 'FRANCE, PARIS' },
  { value: 'LIB', label: 'GABON, LIBREVILLE' },
  { value: 'BAN', label: 'GAMBIA, BANJUL' },
  { value: 'TBL', label: 'GEORGIA, TBILISI' },
  { value: 'BRL', label: 'GERMANY, BERLIN' },
  { value: 'FRN', label: 'GERMANY, FRANKFURT' },
  { value: 'MUN', label: 'GERMANY, MUNICH' },
  { value: 'ACC', label: 'GHANA, ACCRA' },
  { value: 'ATH', label: 'GREECE, ATHENS' },
  { value: 'GTM', label: 'GUATEMALA, GUATEMALA CITY' },
  { value: 'CRY', label: 'GUINEA, CONAKRY' },
  { value: 'GEO', label: 'GUYANA, GEORGETOWN' },
  { value: 'PTP', label: 'HAITI, PORT-AU-PRINCE' },
  { value: 'TGG', label: 'HONDURAS, TEGUCIGALPA' },
  { value: 'BDP', label: 'HUNGARY, BUDAPEST' },
  { value: 'RKJ', label: 'ICELAND, REYKJAVIK' },
  { value: 'JAK', label: 'INDONESIA, JAKARTA' },
  { value: 'SRB', label: 'INDONESIA, SURABAYA' },
  { value: 'BGH', label: 'IRAQ, BAGHDAD' },
  { value: 'ERB', label: 'IRAQ, ERBIL' },
  { value: 'DBL', label: 'IRELAND, DUBLIN' },
  { value: 'TLV', label: 'ISRAEL, TEL AVIV' },
  { value: 'FLR', label: 'ITALY, FLORENCE' },
  { value: 'MLN', label: 'ITALY, MILAN' },
  { value: 'NPL', label: 'ITALY, NAPLES' },
  { value: 'RME', label: 'ITALY, ROME' },
  { value: 'KNG', label: 'JAMAICA, KINGSTON' },
  { value: 'NHA', label: 'JAPAN, NAHA' },
  { value: 'KBO', label: 'JAPAN, OSAKA/FUKUOKA' },
  { value: 'TKY', label: 'JAPAN, TOKYO/SAPPORO' },
  { value: 'JRS', label: 'JERUSALEM' },
  { value: 'AMM', label: 'JORDAN, AMMAN' },
  { value: 'ATA', label: 'KAZAKHSTAN, ALMATY' },
  { value: 'AST', label: 'KAZAKHSTAN, ASTANA' },
  { value: 'NRB', label: 'KENYA, NAIROBI' },
  { value: 'PRI', label: 'KOSOVO, PRISTINA' },
  { value: 'KWT', label: 'KUWAIT, KUWAIT CITY' },
  { value: 'BKK', label: 'KYRGYZSTAN, BISHKEK' },
  { value: 'VNT', label: 'LAOS, VIENTIANE' },
  { value: 'RGA', label: 'LATVIA, RIGA' },
  { value: 'BRT', label: 'LEBANON, BEIRUT' },
  { value: 'MAS', label: 'LESOTHO, MASERU' },
  { value: 'MRV', label: 'LIBERIA, MONROVIA' },
  { value: 'VIL', label: 'LITHUANIA, VILNIUS' },
  { value: 'LXM', label: 'LUXEMBOURG, LUXEMBOURG' },
  { value: 'ANT', label: 'MADAGASCAR, ANTANANARIVO' },
  { value: 'LIL', label: 'MALAWI, LILONGWE' },
  { value: 'KLL', label: 'MALAYSIA, KUALA LUMPUR' },
  { value: 'BAM', label: 'MALI, BAMAKO' },
  { value: 'VLL', label: 'MALTA, VALLETTA' },
  { value: 'MAJ', label: 'MARSHALL ISLANDS, MAJURO' },
  { value: 'NUK', label: 'MAURITANIA, NOUAKCHOTT' },
  { value: 'PTL', label: 'MAURITIUS, PORT LOUIS' },
  { value: 'KOL', label: 'MICRONESIA, KOLONIA' },
  { value: 'CHS', label: 'MOLDOVA, CHISINAU' },
  { value: 'ULN', label: 'MONGOLIA, ULAANBAATAR' },
  { value: 'POD', label: 'MONTENEGRO, PODGORICA' },
  { value: 'CSB', label: 'MOROCCO, CASABLANCA' },
  { value: 'MAP', label: 'MOZAMBIQUE, MAPUTO' },
  { value: 'WHK', label: 'NAMIBIA, WINDHOEK' },
  { value: 'KDU', label: 'NEPAL, KATHMANDU' },
  { value: 'AMS', label: 'NETHERLANDS, AMSTERDAM' },
  { value: 'ACK', label: 'NEW ZEALAND, AUCKLAND' },
  { value: 'MNG', label: 'NICARAGUA, MANAGUA' },
  { value: 'NMY', label: 'NIGER, NIAMEY' },
  { value: 'ABU', label: 'NIGERIA, ABUJA' },
  { value: 'LGS', label: 'NIGERIA, LAGOS' },
  { value: 'SKO', label: 'NORTH MACEDONIA, SKOPJE' },
  { value: 'BLF', label: 'NORTHERN IRELAND, BELFAST' },
  { value: 'OSL', label: 'NORWAY, OSLO' },
  { value: 'MST', label: 'OMAN, MUSCAT' },
  { value: 'ISL', label: 'PAKISTAN, ISLAMABAD' },
  { value: 'KRC', label: 'PAKISTAN, KARACHI' },
  { value: 'KOR', label: 'PALAU, KOROR' },
  { value: 'PNM', label: 'PANAMA, PANAMA CITY' },
  { value: 'PTM', label: 'PAPUA NEW GUINEA, PORT MORESBY' },
  { value: 'ASN', label: 'PARAGUAY, ASUNCION' },
  { value: 'LMA', label: 'PERU, LIMA' },
  { value: 'MNL', label: 'PHILIPPINES, MANILA' },
  { value: 'KRK', label: 'POLAND, KRAKOW' },
  { value: 'WRW', label: 'POLAND, WARSAW' },
  { value: 'LSB', label: 'PORTUGAL, LISBON' },
  { value: 'DOH', label: 'QATAR, DOHA' },
  { value: 'BCH', label: 'ROMANIA, BUCHAREST' },
  { value: 'MOS', label: 'RUSSIA, MOSCOW' },
  { value: 'KGL', label: 'RWANDA, KIGALI' },
  { value: 'APA', label: 'SAMOA, APIA' },
  { value: 'DHR', label: 'SAUDI ARABIA, DHAHRAN' },
  { value: 'JDD', label: 'SAUDI ARABIA, JEDDAH' },
  { value: 'RID', label: 'SAUDI ARABIA, RIYADH' },
  { value: 'DKR', label: 'SENEGAL, DAKAR' },
  { value: 'BLG', label: 'SERBIA, BELGRADE' },
  { value: 'FTN', label: 'SIERRA LEONE, FREETOWN' },
  { value: 'SGP', label: 'SINGAPORE, SINGAPORE' },
  { value: 'BTS', label: 'SLOVAKIA, BRATISLAVA' },
  { value: 'LJU', label: 'SLOVENIA, LJUBLJANA' },
  { value: 'CPT', label: 'SOUTH AFRICA, CAPE TOWN' },
  { value: 'DRB', label: 'SOUTH AFRICA, DURBAN' },
  { value: 'JHN', label: 'SOUTH AFRICA, JOHANNESBURG' },
  { value: 'SEO', label: 'SOUTH KOREA, SEOUL' },
  { value: 'JBA', label: 'SOUTH SUDAN, JUBA' },
  { value: 'MDD', label: 'SPAIN, MADRID' },
  { value: 'CLM', label: 'SRI LANKA, COLOMBO' },
  { value: 'PRM', label: 'SURINAME, PARAMARIBO' },
  { value: 'STK', label: 'SWEDEN, STOCKHOLM' },
  { value: 'BEN', label: 'SWITZERLAND, BERN' },
  { value: 'DHB', label: 'TAJIKISTAN, DUSHANBE' },
  { value: 'DRS', label: 'TANZANIA, DAR ES SALAAM' },
  { value: 'BNK', label: 'THAILAND, BANGKOK' },
  { value: 'CHN', label: 'THAILAND, CHIANG MAI' },
  { value: 'DIL', label: 'TIMOR LESTE, DILI' },
  { value: 'LOM', label: 'TOGO, LOME' },
  { value: 'PTS', label: 'TRINIDAD, PORT OF SPAIN' },
  { value: 'TNS', label: 'TUNISIA, TUNIS' },
  { value: 'ANK', label: 'TURKEY, ANKARA' },
  { value: 'IST', label: 'TURKEY, ISTANBUL' },
  { value: 'AKD', label: 'TURKMENISTAN, ASHGABAT' },
  { value: 'KMP', label: 'UGANDA, KAMPALA' },
  { value: 'KEV', label: 'UKRAINE, KYIV' },
  { value: 'ABD', label: 'UNITED ARAB EMIRATES, ABU DHABI' },
  { value: 'DUB', label: 'UNITED ARAB EMIRATES, DUBAI' },
  { value: 'MTV', label: 'URUGUAY, MONTEVIDEO' },
  { value: 'THT', label: 'UZBEKISTAN, TASHKENT' },
  { value: 'LUS', label: 'ZAMBIA, LUSAKA' },
  { value: 'HRE', label: 'ZIMBABWE, HARARE' },
];

// 安全问题选项
const securityQuestions = [
  { value: '1', label: '您外祖母的名字是什么？' },
  { value: '2', label: '您祖父的名字是什么？' },
  { value: '3', label: '您外祖母的娘家姓是什么？' },
  { value: '4', label: '您小时候家人怎么称呼您？' },
  { value: '5', label: '您在哪个城市遇到您的配偶/重要他人？' },
  { value: '6', label: '您最喜欢的童年朋友叫什么名字？' },
  { value: '7', label: '您8岁时住在哪条街？' },
  { value: '8', label: '您最年长的兄弟姐妹的生日月份和年份是什么？（例如：1900年1月）' },
  { value: '9', label: '您最小的孩子的中间名是什么？' },
  { value: '10', label: '您最年长的兄弟姐妹的中间名是什么？' },
  { value: '11', label: '您11岁时上的是哪所学校？' },
  { value: '12', label: '您小时候家里的电话号码是什么？' },
  { value: '13', label: '您最年长的表兄弟姐妹的姓名是什么？' },
  { value: '14', label: '您最喜欢的毛绒玩具或玩具叫什么名字？' },
  { value: '15', label: '您的父母在哪个城市或城镇相遇？' },
  { value: '16', label: '您最喜欢的老师的姓是什么？' },
  { value: '17', label: '您最近的兄弟姐妹住在哪个城市？' },
  { value: '18', label: '您最小的兄弟姐妹的生日月份和年份是什么？（例如：1900年1月）' },
  { value: '19', label: '您的第一份工作在哪个城市或城镇？' },
  { value: '20', label: '您的第一个男朋友或女朋友叫什么名字？' }
];

// 创建申请模态框组件
const CreateApplicationModal = ({ isOpen, onClose, onCreateApplication }) => {
  const [currentStep, setCurrentStep] = useState('embassy'); // embassy, security, name, photo
  const [selectedEmbassy, setSelectedEmbassy] = useState('');
  const [securityQuestion, setSecurityQuestion] = useState('');
  const [securityAnswer, setSecurityAnswer] = useState('');
  const [applicationName, setApplicationName] = useState('');
  const [photo, setPhoto] = useState(null);

  // 重置表单
  const resetForm = () => {
    setCurrentStep('embassy');
    setSelectedEmbassy('');
    setSecurityQuestion('');
    setSecurityAnswer('');
    setApplicationName('');
    setPhoto(null);
  };

  // 处理关闭
  const handleClose = () => {
    resetForm();
    onClose();
  };

  // 处理创建申请
  const handleCreateApplication = () => {
    // 验证所有必填信息，包括照片
    if (!selectedEmbassy || !securityQuestion || !securityAnswer.trim() || !applicationName.trim() || !photo) {
      alert('请填写所有必填信息并上传照片');
      return;
    }

    // 验证照片上传状态
    if (photo && photo.upload_status === 'error') {
      alert('照片上传失败，请重新上传');
      return;
    }

    const applicationData = {
      title: applicationName.trim(),
      embassy_location: selectedEmbassy,
      security_question: securityQuestion,
      security_answer: securityAnswer.trim(),
      applicant_photo: {
        filename: photo.filename,
        file_size: photo.file_size,
        dimensions: photo.dimensions,
        file_path: photo.file_path,
        url: photo.url,
        upload_status: photo.upload_status || 'completed',
        last_modified: photo.last_modified
      },
      created_at: new Date().toISOString(),
      ...ALL_FORM_FIELDS
    };

    onCreateApplication(applicationData);
    handleClose();
  };

  // 获取大使馆名称
  const getEmbassyName = (code) => {
    const embassy = embassyOptions.find(e => e.value === code);
    return embassy ? embassy.label : code;
  };

  // 获取安全问题文本
  const getSecurityQuestionText = (value) => {
    const question = securityQuestions.find(q => q.value === value);
    return question ? question.label : '';
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-xl w-full mx-4 max-h-[90vh] overflow-y-auto">
        {/* 头部 */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-800">创建新申请</h3>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* 进度指示器 - 更新为4步 */}
        <div className="px-6 py-4 border-b border-gray-200">
          <div className="grid grid-cols-4 gap-2">
            <div className={`flex flex-col items-center ${currentStep === 'embassy' ? 'text-blue-600' : 'text-gray-400'}`}>
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium ${
                currentStep === 'embassy' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-600'
              }`}>
                1
              </div>
              <span className="mt-1 text-xs text-center">选择大使馆</span>
            </div>
            <div className={`flex flex-col items-center ${currentStep === 'security' ? 'text-blue-600' : 'text-gray-400'}`}>
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium ${
                currentStep === 'security' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-600'
              }`}>
                2
              </div>
              <span className="mt-1 text-xs text-center">安全问题</span>
            </div>
            <div className={`flex flex-col items-center ${currentStep === 'name' ? 'text-blue-600' : 'text-gray-400'}`}>
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium ${
                currentStep === 'name' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-600'
              }`}>
                3
              </div>
              <span className="mt-1 text-xs text-center">申请名称</span>
            </div>
            <div className={`flex flex-col items-center ${currentStep === 'photo' ? 'text-blue-600' : 'text-gray-400'}`}>
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium ${
                currentStep === 'photo' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-600'
              }`}>
                4
              </div>
              <span className="mt-1 text-xs text-center">上传照片</span>
            </div>
          </div>
        </div>

        <div className="p-6">
          {/* 步骤1：大使馆选择 */}
          {currentStep === 'embassy' && (
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  请选择预约办理的大使馆 <span className="text-red-500">*</span>
                </label>
                <select
                  value={selectedEmbassy}
                  onChange={(e) => setSelectedEmbassy(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option value="">请选择大使馆</option>
                  {embassyOptions.map(embassy => (
                    <option key={embassy.value} value={embassy.value}>
                      {embassy.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="flex justify-end space-x-3 pt-4">
                <button
                  onClick={handleClose}
                  className="px-4 py-2 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                >
                  取消
                </button>
                <button
                  onClick={() => setCurrentStep('security')}
                  disabled={!selectedEmbassy}
                  className={`px-4 py-2 rounded-lg transition-colors ${
                    selectedEmbassy
                      ? 'bg-blue-600 text-white hover:bg-blue-700'
                      : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                  }`}
                >
                  下一步
                </button>
              </div>
            </div>
          )}

          {/* 步骤2：安全问题 */}
          {currentStep === 'security' && (
            <div className="space-y-4">
              <div>
                <h4 className="text-lg font-semibold text-gray-800 mb-4">安全问题设置</h4>
                <p className="text-sm text-gray-600 mb-4">请选择一个安全问题并回答，用于验证您的身份。</p>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  选择安全问题 <span className="text-red-500">*</span>
                </label>
                <select
                  value={securityQuestion}
                  onChange={(e) => setSecurityQuestion(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option value="">请选择安全问题</option>
                  {securityQuestions.map(question => (
                    <option key={question.value} value={question.value}>
                      {question.label}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  您的答案 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={securityAnswer}
                  onChange={(e) => {
                    // 只允许英文字母（大小写）、数字和空格
                    const value = e.target.value.replace(/[^a-zA-Z0-9\s]/g, '');
                    setSecurityAnswer(value);
                  }}
                  placeholder="请用英文字母或数字填写"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  maxLength={100}
                />
                <p className="text-xs text-amber-600 mt-1">注意：仅支持英文字母和数字，不支持中文</p>
              </div>
              <div className="flex justify-between space-x-3 pt-4">
                <button
                  onClick={() => setCurrentStep('embassy')}
                  className="flex items-center px-4 py-2 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                >
                  <ChevronLeft className="w-4 h-4 mr-1" />
                  返回
                </button>
                <button
                  onClick={() => setCurrentStep('name')}
                  disabled={!securityQuestion || !securityAnswer.trim()}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
                >
                  下一步
                </button>
              </div>
            </div>
          )}

          {/* 步骤3：申请名称 */}
          {currentStep === 'name' && (
            <div className="space-y-4">
              <div>
                <h4 className="text-lg font-semibold text-gray-800 mb-4">申请信息确认</h4>
                <div className="bg-gray-50 p-4 rounded-lg mb-4">
                  <div className="space-y-2 text-sm">
                    <div><span className="font-medium">大使馆:</span> {getEmbassyName(selectedEmbassy)}</div>
                    <div><span className="font-medium">安全问题:</span> {getSecurityQuestionText(securityQuestion)}</div>
                  </div>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  申请名称 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={applicationName}
                  onChange={(e) => setApplicationName(e.target.value)}
                  placeholder="例如：张三的签证申请"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  maxLength={50}
                />
                <p className="text-xs text-gray-500 mt-1">请为这个申请起一个便于识别的名称</p>
              </div>
              <div className="flex justify-between space-x-3 pt-4">
                <button
                  onClick={() => setCurrentStep('security')}
                  className="flex items-center px-4 py-2 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                >
                  <ChevronLeft className="w-4 h-4 mr-1" />
                  返回
                </button>
                <button
                  onClick={() => setCurrentStep('photo')}
                  disabled={!applicationName.trim()}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
                >
                  下一步
                </button>
              </div>
            </div>
          )}

          {/* 步骤4：照片上传 */}
          {currentStep === 'photo' && (
            <div className="space-y-4">
              <div>
                <h4 className="text-lg font-semibold text-gray-800 mb-4">上传申请人照片</h4>

                {/* 照片基本要求提示 */}
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
                  <div className="text-sm text-blue-800">
                    <p className="font-bold mb-2">照片基本要求：</p>
                    <ul className="list-disc list-inside space-y-1">
                      <li>近6个月内拍摄的头像照</li>
                      <li>白底、免冠、不戴眼镜、不遮眉毛和耳朵</li>
                      <li>尺寸约 51×51mm（2×2 inch），电子文件大小一般要求 &lt;240KB</li>
                      <li>尽量不要用美颜/重度修图自拍</li>
                    </ul>
                  </div>
                </div>

                {/* 照片工具提示 - 必须使用官方工具 */}
                <div className="bg-amber-50 border border-amber-300 rounded-lg p-4 mb-4">
                  <div className="text-sm text-amber-900">
                    <p className="font-bold text-amber-800 mb-3">照片必须经过美国国务院官方工具检查</p>
                    <p className="mb-3">请按以下步骤操作：</p>
                    <ol className="list-decimal list-inside space-y-2 mb-3 text-amber-800">
                      <li>点击下方按钮进入官方照片工具页面</li>
                      <li>点击 <span className="font-semibold bg-amber-200 px-1 rounded">"Choose Photo"</span> 选择您的照片</li>
                      <li>点击 <span className="font-semibold bg-amber-200 px-1 rounded">"Accept & Proceed"</span></li>
                      <li>点击 <span className="font-semibold bg-amber-200 px-1 rounded">"Download image to your device"</span> 下载符合要求的照片</li>
                      <li>将下载的照片上传到下方<span className="font-semibold">"申请人照片"</span>区域（点击选择或拖拽）</li>
                    </ol>
                    <a
                      href="https://tsg.phototool.state.gov/photo"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center px-4 py-2 bg-amber-600 text-white text-sm font-medium rounded-md hover:bg-amber-700 transition-colors"
                    >
                      <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
                      </svg>
                      进入官方照片工具
                    </a>
                  </div>
                </div>
              </div>
              
              <PhotoUploadField
                label="申请人照片"
                value={photo}
                onChange={setPhoto}
                required={true}
                maxSize={3 * 1024 * 1024}
                acceptedFormats={['image/jpeg', 'image/jpg', 'image/png']}
                minDimensions={{ width: 300, height: 300 }}
                recommendedDimensions={{ width: 600, height: 600 }}
              />
              
              <div className="flex justify-between space-x-3 pt-4">
                <button
                  onClick={() => setCurrentStep('name')}
                  className="flex items-center px-4 py-2 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                >
                  <ChevronLeft className="w-4 h-4 mr-1" />
                  返回
                </button>
                <button
                  onClick={handleCreateApplication}
                  disabled={!photo}
                  className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
                >
                  创建申请
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreateApplicationModal;
